<template>
  <Dialog :open="true" @close="props.onClose">
    <div class="fixed inset-0 flex items-center justify-center p-4 z-20 bg-zinc-700/90">
      <DialogPanel class="border border-white w-[800px] max-h-[90vh] flex flex-col bg-black">
        <DialogTitle class="border-b border-white p-3 text-yellow-300">
          {{ props.title_text }}
        </DialogTitle>

        <div class="mt-6 pl-6 pr-2 flex flex-col">
          <p>
            {{ props.prompt_text }}
          </p>
        </div>

        <div class="w-full min-h-24 px-6 py-4 flex justify-center items-center z-10">
          <DTButton type="success" class="py-1 px-5" @click="onYesClick">
            {{ text('ui.yes') }}
          </DTButton>
          <DTButton type="error" class="ml-3 py-1 px-5" @click="props.onClose">
            {{ text('ui.no') }}
          </DTButton>
        </div>

        <div
          v-if="props.dont_ask_again_storage_key && props.dont_ask_again_label"
          class="w-full flex items-center justify-end gap-2 py-2 px-4"
        >
          <input
            id="ConfirmDecisionModal_dont_ask_again"
            v-model="dont_ask_again_checked"
            type="checkbox"
            class="h-4 w-4 shrink-0 accent-yellow-200 bg-white/80"
          />
          <label
            for="ConfirmDecisionModal_dont_ask_again"
            class="cursor-pointer select-none text-sm text-white/60 text-zinc-200"
          >
            {{ props.dont_ask_again_label }}
          </label>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup>
import { onUnmounted, ref } from 'vue';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';
import text from '~/text';
import { DTButton } from '~/view/components/common/DOM';

const dont_ask_again_checked = ref(false);

const props = defineProps({
  title_text: {
    type: String,
    required: true,
  },
  prompt_text: {
    type: String,
    required: true,
  },
  onConfirmed: {
    type: Function,
    required: true,
  },
  onClose: {
    type: Function,
    required: true,
  },
  dont_ask_again_label: {
    type: String,
    default: '',
  },
  dont_ask_again_storage_key: {
    type: String,
    default: '',
  },
  /** Runs when this modal unmounts (any close path). Use for canvas cleanup; avoid relying on Dialog @close alone (spurious events on mount). */
  onClosed: {
    type: Function,
    default: undefined,
  },
});

onUnmounted(() => {
  props.onClosed?.();
});

function onYesClick() {
  if (props.dont_ask_again_storage_key && dont_ask_again_checked.value) {
    localStorage.setItem(props.dont_ask_again_storage_key, 'true');
  }
  props.onConfirmed();
  props.onClose();
}
</script>
